<template>
  <div class="brandStreet" ref="container">
    <van-row class="title">
      <van-col span="8"></van-col>
      <van-col span="8" class="logo">
        <img src="@/assets/images/store_street.png" alt="" />
      </van-col>
      <van-col span="8"></van-col>
    </van-row>
    <van-row span="24" class="container">
      <div class="content" v-for="(item, index) in store_list" :key="index">
        <van-row style="height: 2em"></van-row>
        <router-link
          :to="{
            path: '/store/detail/' + item.id,
          }"
        >
          <van-row class="brand">
            <van-col class="logo">
              <img v-if="item.logo != ''" :src="item.logo" />
              <img v-else src="@/assets/images/public.png" />
            </van-col>
            <van-col class="text">
              <div class="name">{{ item.store_name }}</div>
              <div class="phone">{{ item.tel }}</div>
              <span class="count">{{ item.product_count }}件商品</span>
            </van-col>
            <van-col class="icon">
              <van-icon name="arrow" />
            </van-col>
          </van-row>
        </router-link>

        <swiper
          class="swiper-wrapper brand-wrapper activity-swiper"
          :options="swiperProducts"
        >
          <div
            class="swiper-slide item brand-slide"
            v-for="(t_item, t_index) in item.product_list"
            :key="t_index"
          >
            <router-link
              :to="{
                path: '/detail/' + t_item.id,
              }"
              class=""
            >
              <div class="pictrue">
                <img :src="t_item.image" />
              </div>
              <span class="name line1">{{ t_item.keyword }}</span>
              <span class="price"
                ><span v-show="t_item.price !== '请先登录'">￥</span
                >{{ t_item.price }}</span
              >
            </router-link>
          </div>
        </swiper>
      </div>
    </van-row>
    <Loading :loaded="loadend" :loading="loading"></Loading>
  </div>
</template>

<script>
import Vue from "vue";
import Loading from "@components/Loading";
import debounce from "lodash.debounce";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { shopStreet, shopIndex, shopApply } from "@/api/store.js";
import { Row, Col } from "vant";
import { Tab, Tabs } from "vant";
import { Icon } from "vant";

Vue.use(Row)
  .use(Col)
  .use(Tab)
  .use(Tabs)
  .use(Icon);
export default {
  name: "StoreStreet",
  components: {
    swiper,
    swiperSlide,
    Loading,
  },
  data() {
    return {
      swiperProducts: {
        freeMode: true,
        freeModeMomentum: false,
        slidesPerView: "auto",
        observer: true,
        observeParents: true,
        speed: 2000,
        loop: true,
        autoplay: {
          disableOnInteraction: true,
          delay: 1000,
        },
      },
      store_list: [],
      page: 1,
      limit: 8,
      loading: false,
      loadend: false,
    };
  },
  mounted() {
    this.getStoreList();
    this.$scroll(this.$refs.container, () => {
      !this.loading && this.getStoreList();
    });
  },
  methods: {
    getStoreList: debounce(function() {
      let that = this;
      if (that.loading) return; //阻止下次请求（false可以进行请求）；
      if (that.loadend) return; //阻止结束当前请求（false可以进行请求）；
      that.loading = true;
      shopStreet({
        page: this.page,
        limit: this.limit,
      }).then((res) => {
        that.loading = false;
        that.store_list.push.apply(that.store_list, res.data.shop_list);
        that.loadend = res.data.shop_list.length < that.limit; //判断所有数据是否加载完成；
        that.page = that.page + 1;
      });
    }),
  },
};
</script>

<style scoped>
.item {
  width: 31%;
  border: 1px solid #eee;
  border-radius: 0.12rem;
  margin-right: 1em;
}

.item img {
  width: 6.5em;
  height: 6.5em;
}

.item .name {
  color: #333;
  font-size: 0.8em;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
  height: 2em;
  line-height: 2em;
  display: block;
}

.item .price {
  color: #e82440;
  font-weight: bold;
  font-size: 1em;
  text-align: center;
}
</style>
